import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from '../components/Header';
import { MenuDrawer } from '../components/MenuDrawer';
import { Hero } from '../components/Hero';
import { ConciergeRequestBar } from '../components/ConciergeRequestBar';
import { ServiceAreas } from '../components/ServiceAreas';
import { ConciergeExtras } from '../components/ConciergeExtras';
import { Destinations } from '../components/Destinations';
import { Experiences } from '../components/Experiences';
import { Faq } from '../components/Faq';
import { CallbackBar } from '../components/CallbackBar';
import { News } from '../components/News';
import { Membership } from '../components/Membership';
import { ExperientialSeries } from '../components/ExperientialSeries';
export function Home() {
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = useCallback(() => setMenuOpen(false), []);
  const {
    hash
  } = useLocation();
  useEffect(() => {
    document.title = 'Superluxury — Private Concierge, by Introduction Only';
  }, []);

  // Arriving from a subpage with a section link (e.g. /#faq) — scroll to that section
  useEffect(() => {
    if (!hash) return;
    const id = window.setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView(), 50);
    return () => window.clearTimeout(id);
  }, [hash]);
  return <>
      <Header onOpenMenu={() => setMenuOpen(true)} data-id="element-1510" data-mp="2hy70qw5q165l" />
      <MenuDrawer open={menuOpen} onClose={closeMenu} data-id="element-1511" data-mp="2i0070acf9od2" />
      <main data-id="element-1512" data-mp="2d65rlj3unvjs">
        <Hero data-id="element-1513" data-mp="2d5mb86tulf7v" />
        {/* Tablet and mobile: request bar directly below the film */}
        <div className="lg:hidden" data-id="element-1514" data-mp="2895jz3rcqkqk">
          <ConciergeRequestBar data-id="element-1515" data-mp="2861dfzqezcwq" />
        </div>
        <ServiceAreas data-id="element-1516" data-mp="239sqw19w0hfj" />
        <ConciergeExtras data-id="element-1517" data-mp="23acb5on0fhwq" />
        <Experiences data-id="element-1518" data-mp="236y7md2m12np" />
        <Membership data-id="element-1519" data-mp="1z765oj7q1urb" />
        <Destinations data-id="element-1520" data-mp="1z7pdh73nr2rm" />
        <ExperientialSeries data-id="element-1521" data-mp="1z64khlwzrrvv" />
        <News data-id="element-1522" data-mp="1z98syvhhp9sc" />
        <Faq data-id="element-1523" data-mp="1u8coafpbdjlv" />
        <CallbackBar data-id="element-1524" data-mp="1u7t8b4j855ah" />
      </main>
    </>;
}